import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "absolute flex items-center justify-center w-full h-full rounded-md z-10 bg-neutral-700 bg-opacity-75"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.state.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.state.bg)
        }, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.state.component), { onOnUpdate: _ctx.handleModal }, null, 40, ["onOnUpdate"]))
        ], 2)
      ]))
    : _createCommentVNode("", true)
}